import type { IOrganizationData } from '@carboncopyco/types';
import { settings } from '../../../settings';

export const useCustomDomain = (organization: IOrganizationData) => {
  if (
    !organization ||
    !organization.customDomains ||
    !organization.enableCustomDomain
  ) {
    return '';
  }
  return settings.DESKTOP_SHOWTIME_URL || organization.customDomains[0];
};
